"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.form.title.label': '问题标题 <span class="text-danger">*</span>',
    'question.form.title.placeholder': '输入问题标题',
    'question.form.type.label': '问题类型',
    'question.form.type.placeholder': '选择问题类型',
    'question.form.required.label': '必填',
    'question.form.description.label': '描述（可选）',
    'question.form.description.placeholder': '输入问题描述',
    'question.form.options.label': '选项',
    'question.form.options.add': '添加选项',
    'question.form.option.value.placeholder': '选项值',
    'question.form.option.label.placeholder': '选项标签',
    'question.form.option.remove': '删除选项',
    'question.form.options.empty': '尚未添加选项。点击"添加选项"开始。',
};
